import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import type { PackageEstimates } from '@openx/types/package';
import { getFormattedAmountValue } from '@openx/utils/lib/getFormattedAmountValue';
import { useTranslation } from 'react-i18next';
import { getEstimateRangeText } from '../../../utils/getEstimateRangeText';
import { wholeEstimatesEmpty } from '../../../utils/isEstimateEmpty';

type PackageEstimatedRangesSectionProps = {
  estimates?: PackageEstimates | null;
};

export const PackageEstimatedRangesSection = ({ estimates }: PackageEstimatedRangesSectionProps) => {
  const { t } = useTranslation();

  if (!estimates || wholeEstimatesEmpty(estimates)) return null;

  return (
    <Stack
      sx={{
        borderLeft: '1px solid',
        borderColor: 'divider',
        padding: '0 24px',
        width: '40%',
      }}
    >
      <Typography
        variant="h3"
        data-test="package-range-title"
        sx={{
          width: '100%',
          mb: 1.5,
        }}
      >
        {t('Ranges')}
      </Typography>

      {!!estimates.cpm && estimates.cpm.low !== '' && (
        <FieldDetails
          title={t('CPM')}
          value={getEstimateRangeText(estimates?.cpm, v => `$${getFormattedAmountValue(v)}`)}
          dataTest="range-cpm"
        />
      )}

      {!!estimates.reach && estimates.reach.low !== '' && (
        <FieldDetails
          title={t('Unique Reach')}
          value={getEstimateRangeText(estimates?.reach, v => v.toString(), 'M')}
          dataTest="range-reach"
        />
      )}

      {!!estimates.market_requests && estimates.market_requests.low !== '' && (
        <FieldDetails
          title={t('Market Requests Volume (Monthly) ')}
          value={getEstimateRangeText(estimates?.market_requests, v => v.toString(), 'M')}
          dataTest="range-market-requests"
        />
      )}
    </Stack>
  );
};
